/**
 * All methods are static.
 */
export default class Logger {
  static Level = {
    NONE: "NONE",
    ERROR: "ERROR",
    WARN: "WARN",
    INFO: "INFO",
    DEBUG: "DEBUG",
    TRACE: "TRACE",
  } as const;

  static Severity = {
    NONE: 0,
    ERROR: 1,
    WARN: 2,
    INFO: 3,
    DEBUG: 4,
    TRACE: 5,
  } as const;

  // eslint-disable-next-line no-use-before-define
  static level: keyof typeof Logger.Level = Logger.Level.NONE;

  static logMessage(logLevel: keyof typeof Logger.Level, message: any): void {
    if (Logger.Severity[Logger.level] >= Logger.Severity[logLevel]) {
      let logger: "warn" | "error" = "warn";
      if (logLevel === Logger.Level.ERROR) {
        logger = "error";
      }
      // eslint-disable-next-line no-console
      console[logger](`${logLevel}: ${toString(message)}`);
    }
  }

  static error(message: any): void {
    return Logger.logMessage(Logger.Level.ERROR, message);
  }

  static warn(message: any): void {
    return Logger.logMessage(Logger.Level.WARN, message);
  }

  static info(message: any): void {
    return Logger.logMessage(Logger.Level.INFO, message);
  }

  static debug(message: any): void {
    return Logger.logMessage(Logger.Level.DEBUG, message);
  }

  static trace(message: any): void {
    return Logger.logMessage(Logger.Level.TRACE, message);
  }
}

// Default level
Logger.level = Logger.Level.NONE;

/**
 * Creates a string representation of object, array or string
 * @param val
 * @returns string
 */
export function toString(val: any): string {
  if (typeof val === "object") {
    try {
      return JSON.stringify(val);
    } catch (e) {
      Logger.error(e);
      return String(val);
    }
  }
  if (Array.isArray(val)) {
    return val.toString();
  }
  return String(val);
}
